import { createAsyncThunk } from '@reduxjs/toolkit'
import MetricResult from './metric-result-model'
import {
  delete_metricResult,
  load_metricResults,
  store_metricResult,
} from './metricResult-service'

export const LoadMetricResultsAsync = createAsyncThunk<any, any>(
  'composer/load/metricResult',
  async (params: { uid: string }) => {
    return await load_metricResults(params)
  },
)

export const CreateMetricResultAsync = createAsyncThunk<any, any>(
  'composer/create/metricResult',
  async (params: MetricResult) => {
    return await store_metricResult(params)
  },
)

export const DeleteMetricResultAsync = createAsyncThunk<any, any>(
  'composer/delete/metricResult',
  async (params) => {
    return await delete_metricResult(params)
  },
)
